import React from "react";
import { Modal, Box, Typography, IconButton, Fade } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import "./ServiceInfoModal.css";

interface Service {
  id: number;
  name: string;
  cesname: string;
  serviceType: string;
  visibility: boolean;
  link: string;
  categoryName?: string;
  modifierName?: string;
  isPopular?: boolean;
  description?: string;
}

interface ServiceInfoModalProps {
  open: boolean;
  onClose: () => void;
  service: Service | null;
}

const ServiceInfoModal: React.FC<ServiceInfoModalProps> = ({
  open,
  onClose,
  service,
}) => {
  if (!service) return null;

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open}>
        <Box className="service-info-modal">
          <Box className="service-info-modal__header">
            <Typography variant="h5" component="h2">
              {service.name}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            variant="body1"
            className="service-info-modal__description"
            dangerouslySetInnerHTML={{
              __html: service?.description || "No description available.",
            }}
          ></Typography>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ServiceInfoModal;
